import directives from './module';

directives.directive('formAutofillFix', () =>
        (scope: ng.IScope, elem: any, attrs: any) => {
            // Fixes Chrome bug: https://groups.google.com/forum/#!topic/angular/6NlucSskQjY
            elem.prop('method', 'POST');

            // Fix autofill issues where Angular doesn't know about autofilled inputs
            if (attrs.ngSubmit) {
                setTimeout(function () {
                    elem.unbind('submit').bind('submit', function (e: Event) {
                        e.preventDefault();
                        const arr = elem.find('input');
                        if (arr.length > 0) {
                            arr.triggerHandler('input').triggerHandler('change').triggerHandler('keydown');
                            scope.$apply(attrs.ngSubmit);
                        }
                    });
                }, 0);
            }
        }
);



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/formAutofillFixDirective.ts